import { render, staticRenderFns } from "./Electrical.vue?vue&type=template&id=6232b182&scoped=true"
import script from "./Electrical.vue?vue&type=script&lang=js"
export * from "./Electrical.vue?vue&type=script&lang=js"
import style0 from "./Electrical.vue?vue&type=style&index=0&id=6232b182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6232b182",
  null
  
)

export default component.exports